export default "__VITE_ASSET__TbL1X4R7__"